import { RESET_WALLPAPER_COLOR, SET_WALLPAPER_COLOR, SET_WALLPAPER_PREVIEW_COLOR, WALLPAPER_PREVIEW_SECTION } from "../Actions/Constants";
import { WALLPAPER_COLOR_CODES } from "../Helpers/Constants";

const initialState = {
  color: WALLPAPER_COLOR_CODES[0],
  previewColor: WALLPAPER_COLOR_CODES[0],
  previewSection: false,
};

const WallpaperReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WALLPAPER_COLOR:
      return {
        ...state,
        color: action.payload.color,
      };

    case RESET_WALLPAPER_COLOR:
      return {
        ...state,
        color: WALLPAPER_COLOR_CODES[0],
      };

    case WALLPAPER_PREVIEW_SECTION:
      return {
        ...state,
        previewSection: action.payload.previewSection,
      };

    case SET_WALLPAPER_PREVIEW_COLOR:
      return {
        ...state,
        previewColor: action.payload.previewColor,
      };

    default:
      return state;
  }
};

export default WallpaperReducer;